const PLANS = [
  {
    label: "Free",
    id: "free",
    price: 0,
  },
  // {
  //   label: "Demo",
  //   id: "demo",
  //   price: 0,
  // },
  {
    label: "Starter",
    id: "basic",
    price: 15,
    canBuy: true,
  },
  {
    label: "Pro",
    id: "premium",
    price: 25,
    canBuy: true,
  },
  {
    label: "Business",
    id: "enterprise",
    price: 59,
    canBuy: true,
  },
  {
    label: "Saaszilla - Tier 1",
    id: "saaszilla-1",
    price: 49,
    lifetime: true,
  },
  {
    label: "Saaszilla - Tier 2",
    id: "saaszilla-2",
    price: 99,
    lifetime: true,
  },
  {
    label: "Saaszilla - Tier 3",
    id: "saaszilla-3",
    price: 299,
    lifetime: true,
  },
  {
    label: "Saaszilla - Tier 4",
    id: "saaszilla-4",
    price: 599,
    lifetime: true,
  },
  {
    label: "Appsumo - Tier 1",
    id: "appsumo-1",
    price: 59,
    lifetime: true,
  },
  {
    label: "Appsumo - Tier 2",
    id: "appsumo-2",
    price: 119,
    lifetime: true,
  },
  {
    label: "Appsumo - Tier 3",
    id: "appsumo-3",
    price: 299,
    lifetime: true,
  },
  {
    label: "Appsumo - Tier 4",
    id: "appsumo-4",
    price: 599,
    lifetime: true,
  },
  {
    label: "Appsumo - Tier 5",
    id: "appsumo-5",
    price: 999,
    lifetime: true,
  },
];


module.exports = {
  PLANS,
};